import { render, staticRenderFns } from "./FeedbackPrompt.vue?vue&type=template&id=6331bbfa&scoped=true"
import script from "./FeedbackPrompt.vue?vue&type=script&lang=ts"
export * from "./FeedbackPrompt.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackPrompt.vue?vue&type=style&index=0&id=6331bbfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6331bbfa",
  null
  
)

export default component.exports